import React from 'react';
import homeStyles from './index.module.scss';
import Home from '../components/pages/home';

export default function IndexPage() {
	return <Home />;
}
